module.exports = __webpack_public_path__ + "static/soc3-7e7fc8e5d8ef61cfab7c78a7cc99159d.png";